module.exports = __webpack_public_path__ + "static/img/cha4.fe767f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha4.png
// module id = MPzD
// module chunks = 1